export const super4Mock = [[
{
  "isSuccess": true,
  "data": [
    [
      {
        "id": 587,
        "codigoVendedor": "00230368",
        "nomeVendedor": "LEANDRO MARTINS PEREIRA",
        "baseSuper4": [
          {
            "positivacaoCimento": 144.55555555555554,
            "positivacaoColante": 145.44444444444446,
            "percentMediaDp": 0.8647783067503757,
            "mediaJsm": 0.4358352244208324,
            "ytd": true
          },
          {
            "anoMes": "2026-06-01T00:00:00",
            "positivacaoCimento": 148,
            "positivacaoColante": 144,
            "percentMediaDp": 0.47928994082840237,
            "mediaJsm": 0.9254385964912282,
            "ytd": false
          },
          {
            "anoMes": "2026-07-01T00:00:00",
            "positivacaoCimento": 144,
            "positivacaoColante": 143,
            "percentMediaDp": 0.47928994082840237,
            "mediaJsm": 0.9826388888888888,
            "ytd": false
          },
          {
            "anoMes": "2026-08-01T00:00:00",
            "positivacaoCimento": 142,
            "positivacaoColante": 143,
            "percentMediaDp": 0.46153846153846156,
            "mediaJsm": 0.766899766899767,
            "ytd": false
          },
          {
            "anoMes": "2026-09-01T00:00:00",
            "positivacaoCimento": 136,
            "positivacaoColante": 133,
            "percentMediaDp": 0.46153846153846156,
            "mediaJsm": 0.8037037037037037,
            "ytd": false
          }
        ],
        "createdAt": "2026-09-25T09:20:30.1936587"
      },
      {
        "id": 212,
        "codigoVendedor": "119198",
        "nomeVendedor": "FABRINE PERUSSA NOBREGA MORAIS",
        "baseSuper4": [
          {
            "positivacaoCimento": 0.16666666666666666,
            "positivacaoColante": 0,
            "percentMediaDp": 0.16666666666666666,
            "mediaJsm": 0,
            "ytd": true
          },
          {
            "anoMes": "2026-08-01T00:00:00",
            "positivacaoCimento": 1,
            "positivacaoColante": 0,
            "percentMediaDp": 0,
            "mediaJsm": 1,
            "ytd": false
          },
          {
            "anoMes": "2026-09-01T00:00:00",
            "positivacaoCimento": 0,
            "positivacaoColante": 0,
            "percentMediaDp": 0,
            "mediaJsm": 0,
            "ytd": false
          }
        ],
        "createdAt": "2026-09-25T09:20:30.1936587"
      }
    ]
  ],
  "existentes": []
}
]]